<template>
  <div id="app" ref="scollElement" :class="lang">
    <div style="height: 101%">
      <Header v-if="this.$route.name !== 'ptclDetailLink'"></Header>
      <router-view />
    </div>
  </div>
</template>

<script>
// import { getScrollOffset, getViewOffset } from '@/util/util.js'
export default {
  name: 'App',
  components: {
    Header: () => import('@/components/Header.vue')
  },
  updated() {
    // router 跳转后回到顶部
    this.$nextTick(() => {
      // console.log('app Update')
      if (this.$refs.scollElement) {
        // console.log('update scrollTo==0')
        this.$refs.scollElement.scrollTop = 0
      }
    })
  },
  computed: {
    lang() {
      return this.$store.getters.getLang
    }
  },
  methods: {}
}
</script>

<style lang="less" scoped></style>



// WEBPACK FOOTER //
// src/App.vue